import { render, staticRenderFns } from "./Lastlogins.vue?vue&type=template&id=d6e54d62&"
import script from "./Lastlogins.vue?vue&type=script&lang=js&"
export * from "./Lastlogins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports